const formrules = {
  requiredSelected: (value) => !!value || 'Preenchimento obrigatório.',
  required: (value) => !!value && (value && value.trim().length !== 0) || 'Preenchimento obrigatório.',
  phone: (value) => !value || (value && (value.length === 14 || value.length === 15)) || 'Formato inválido.',
  cnpj: (value) => {
    const messageInvalidCNPJ = 'Formato inválido.';
    
    if (value && value.length === 18) {
      value = value.replace(/[^\d]+/g, '');
      
      if (value === '00000000000000' || value === '11111111111111'            
        || value === '22222222222222' || value === '33333333333333'            
        || value === '44444444444444' || value === '55555555555555'            
        || value === '66666666666666' || value === '77777777777777'            
        || value === '88888888888888' || value === '99999999999999') {
        return messageInvalidCNPJ;
      }
      
      let size = value.length - 2;
      let numbers = value.substring(0, size);
      const digits = value.substring(size);
      let sum = 0;
      let position = size - 7;
      
      for (let i = size; i >= 1; i--) {
        sum += numbers.charAt(size - i) * (position--);
        if (position < 2) {
          position = 9;
        }
      }
      
      let result = sum % 11 < 2 ? 0 : (11 - (sum % 11));
      
      if (result !== Number(digits.charAt(0))){
        return messageInvalidCNPJ;
      }
      
      size += 1;
      numbers = value.substring(0, size);
      sum = 0;
      position = size - 7;
      
      for (let i = size; i >= 1; i--) {
        sum += numbers.charAt(size - i) * position--;
        if (position < 2) {
          position = 9;
        }
      }
      
      result = sum % 11 < 2 ? 0 : (11 - (sum % 11));
      
      if (result !== Number(digits.charAt(1))){
        return messageInvalidCNPJ;
      }
      
      return true;
    }
    return messageInvalidCNPJ;
  },
  cnpjNotRequired: (value) => (!value || (value && value.length === 18)) || 'Formato inválido.',
  cpfCnpj: (value) => (value && (value.length === 14 || value.length === 18)) || 'Formato inválido.',
  cep: (value) => (value && value.length === 9) || 'Formato inválido.',
  email: (value) => {
    if (value && value.length > 0) {
      const pattern = /^(([^<>(){}!#$%^=+*[\]\\.,;:\s@"]+(\.[^<>(){}!#$%^=+*[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return pattern.test(value) || 'Formato inválido.';
    }
    return true;
  },
}

export {
  formrules
}
